export class AbmBiMap<K, V>{
    private kv: Map<K, V> = new Map();
    private vk: Map<V, K> = new Map();

    get size() {
        return this.kv.size;
    }

    public set(key: K, value: V): V {

        const oldValue = this.kv.get(key);

        this.kv.set(key, value);
        this.vk.set(value, key);
        return oldValue;
    }

    public getFromKey(key: K) {
        return this.kv.get(key);
    }

    public getFromValue(val: V) {
        return this.vk.get(val);
    }

    public keys() {
        return this.kv.keys();
    }

    public values() {
        return this.kv.values();
    }

    public isEmpty(): boolean {
        return this.kv.size === 0;
    }

    public kvEntries() {
        return this.kv.entries();
    }

    public vkEntries() {
        return this.vk.entries();
    }

    public deleteFromKey(key: K) {
        const value = this.kv.get(key);
        let success = this.kv.delete(key);
        if (value) {
            success = this.vk.delete(value);
        }
        return success;
    }

    public deleteFromValue(val: V) {
        const key = this.vk.get(val);
        let success = this.vk.delete(val);
        if (key) {
            success = this.kv.delete(key);
        }
        return success;
    }
}
